import { fetcher } from '../../configure'

export type ResetUserPasswordStatus = 'SUCCESS' | 'USER_DOESNT_EXISTS' | 'INTERNAL_ERROR'

export type ResetPasswordResponse = {
	success: boolean
	status: ResetUserPasswordStatus
}

export type ResetPasswordRequest = {
	email: string
}

export type ResetPasswordEndpoint = (
	request: ResetPasswordRequest
) => Promise<ResetPasswordResponse>

export const requestPasswordReset: ResetPasswordEndpoint = async (request) => {
	return await fetcher({
		method: 'get',
		path: `/users/request-password-reset/`,
        queryParams: { 
            email: request.email
        }
	})
}
